<template>
  <div class="card-header m-b-10">
    <form
      class="box-search"
      @reset.prevent="triggerFilter(false)"
      @submit.prevent="triggerFilter()"
    >
      <div class="form-group">
        <input
          type="text"
          v-model.trim="fieldSearch.fullTextSearch"
          class="form-control f12 hc-37"
          placeholder="Từ khóa"
        />
      </div>

      <div class="form-group">
        <Select2 v-model="fieldSearch.keeperId" :options="dataKeeper" placeholder="Thủ kho" />
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.regionId"
          :options="Config.getSearch(dataConfigRegion)"
          placeholder="Vùng"
        />
      </div>

      <div class="form-group">
        <DateRangePicker
          class="w-100"
          :ranges="false"
          v-model="fieldSearch.activeDate"
          :locale-data="Config.localeData"
        >
          <template v-slot:input="picker">
            <label v-if="picker.startDate && picker.endDate" class="align-middle text-center">
              {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
            </label>
            <label
              v-else
              style="min-width: 13.5em"
              class="align-middle font-size-12 time-placeholder"
            >
              Thời gian kích hoạt
            </label>
          </template>
        </DateRangePicker>
        <span
          v-show="fieldSearch.activeDate.startDate || fieldSearch.activeDate.endDate"
          class="position-absolute"
          style="right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer"
          @click="clearTime(fieldSearch.activeDate)"
        >
          ✕
        </span>
      </div>

      <div class="form-group">
        <DateRangePicker
          class="w-100"
          :ranges="false"
          v-model="fieldSearch.expiredDate"
          :locale-data="Config.localeData"
        >
          <template v-slot:input="picker">
            <label
              v-if="picker.startDate && picker.endDate"
              style="min-width: 11.5em"
              class="align-middle text-center"
            >
              {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
            </label>
            <label
              v-else
              style="min-width: 13.5em"
              class="align-middle font-size-12 time-placeholder"
            >
              Thời gian hết hạn
            </label>
          </template>
        </DateRangePicker>
        <span
          v-show="fieldSearch.expiredDate.startDate || fieldSearch.expiredDate.endDate"
          class="position-absolute"
          style="right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer"
          @click="clearTime(fieldSearch.expiredDate)"
        >
          ✕
        </span>
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.status"
          :options="mapDataFilter(Config.listOptionStatus)"
          placeholder="Tình trạng sim"
        />
      </div>

      <!-- new -->
      <div class="form-group">
        <Select2
          v-model="fieldSearch.supplier"
          :options="mapDataFilter(Config.listOptionSupplier)"
          placeholder="Nhà cung cấp"
        />
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.source"
          :options="mapDataFilter(Config.listOptionSource)"
          placeholder="Đơn vị bán"
        />
      </div>

      <div class="form-group">
        <input
          type="text"
          v-model.trim="fieldSearch.updateBy"
          class="form-control f12 hc-37"
          placeholder="Email người cập nhật"
        />
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.authenStatus"
          :options="mapDataFilter(Config.listOptionAuthenStatusFilter)"
          placeholder="Trạng thái xác thực"
        />
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.status"
          :options="
            mapDataFilter(
              optionStatus.filter(
                s => !['EXPORTED', 'LENT', 'LENT_WARRANTY', 'EXPORT_RENT'].includes(s.id)
              )
            )
          "
          placeholder=" Trạng thái sim"
        />
      </div>

      <div class="form-group form-group-action action-h">
        <button type="submit" ref="submitButtonRef" class="pt-2 mr-2 btn btn-primary hc-37">
          <i class="bx bx-filter-alt"></i> Lọc
        </button>
        <button type="reset" class="pt-2 mr-2 btn btn-outline-light hc-37">
          <i class="bx bx-filter-alt"></i> Bỏ lọc
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import cloneDeep from 'lodash/cloneDeep'
  import { showMess } from '@/config/utils'
  import { StaffService } from '@/services/staff.service'
  import moment from 'moment'

  const searchDefault = {
    fullTextSearch: '',
    keeperId: '',
    status: '',
    regionId: '',
    supplier: '', // Mới
    source: '', // Mới
    updateBy: '', // Mới
    authenStatus: '', // Mới
    simStatus: '', // Mới
    expiredDate: {
      startDate: moment().startOf('day').subtract(3, 'days').toDate(),
      endDate: moment().startOf('day').toDate(),
    },
    activeDate: {
      startDate: null,
      endDate: null,
    },
  }
  export default {
    name: 'FilterSimForm',
    data() {
      return {
        Config,
        optionStatus: Config.statusDevices || [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataKeeper: [],
        dataConfigRegion: [],
        fieldSearch: { ...cloneDeep(searchDefault) },
      }
    },
    async mounted() {
      await this.fetchDataKeeper()
      await this.getRegions()
      this.$refs.submitButtonRef.click()
    },
    computed: {
      typeBagdeOfStatus() {
        return id => {
          return this.mapStatus[id]
        }
      },
    },
    methods: {
      mapDataFilter(list) {
        return [{ id: 0, text: 'Tất cả' }, ...(list || [])]
      },
      triggerFilter(isFilter = true) {
        if (!isFilter) {
          this.fieldSearch = { ...cloneDeep(searchDefault) }
        }
        const params = this.params()
        this.$emit('change', params)
      },
      clearTime(value) {
        value.startDate = null
        value.endDate = null
      },
      formatDateTimeParams(date) {
        return moment(date).startOf('day').add(7, 'hours').valueOf()
      },
      params() {
        const body = {}
        if (this.fieldSearch.fullTextSearch)
          body.fullTextSearch = this.fieldSearch.fullTextSearch.trim()
        if (this.fieldSearch.keeperId && this.fieldSearch.keeperId !== '0')
          body.keeperId = this.fieldSearch.keeperId
        if (this.fieldSearch.regionId && this.fieldSearch.regionId !== '0')
          body.regionId = this.fieldSearch.regionId
        if (this.fieldSearch.status && this.fieldSearch.status !== '0')
          body.status = this.fieldSearch.status

        // Mới thêm
        if (this.fieldSearch.supplier && this.fieldSearch.supplier !== '0') {
          // Map supplier: VIETTEL -> SIMVIETTEL, MOBIFONE -> SIMMOBI, VNSKY -> SIMSKY
          const supplierMap = {
            VIETTEL: 'SIMVIETTEL',
            MOBIFONE: 'SIMMOBI',
            VNSKY: 'SIMSKY',
          }
          body.supplier = supplierMap[this.fieldSearch.supplier] || this.fieldSearch.supplier
        }
        if (this.fieldSearch.source && this.fieldSearch.source !== '0')
          body.source = this.fieldSearch.source
        if (this.fieldSearch.updateBy) body.updateBy = this.fieldSearch.updateBy.trim()
        if (this.fieldSearch.authenStatus && this.fieldSearch.authenStatus !== '0')
          body.authenStatus = this.fieldSearch.authenStatus
        if (this.fieldSearch.simStatus && this.fieldSearch.simStatus !== '0')
          body.simStatus = this.fieldSearch.simStatus

        if (this.fieldSearch.expiredDate.startDate || this.fieldSearch.expiredDate.endDate) {
          body.expiredDateFrom = this.formatDateTimeParams(this.fieldSearch.expiredDate.startDate)
          body.expiredDateTo = this.formatDateTimeParams(this.fieldSearch.expiredDate.endDate)
        }
        if (this.fieldSearch.activeDate.startDate || this.fieldSearch.activeDate.endDate) {
          body.activeDateFrom = this.formatDateTimeParams(this.fieldSearch.activeDate.startDate)
          body.activeDateTo = this.formatDateTimeParams(this.fieldSearch.activeDate.endDate)
        }
        return body
      },
      async fetchDataKeeper() {
        try {
          const { data } = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          this.dataKeeper = data.map(e => {
            return {
              id: e.userId,
              text: `${e.name} - ${e.userName}`,
            }
          })
          this.dataKeeper.unshift({ id: '0', text: 'Tất cả' })
        } catch (error) {
          showMess(
            this,
            'Error',
            error.response?.data?.message || error.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            3000
          )
        }
      },
      async getRegions() {
        try {
          const data = await StaffService.getRegions()
          if (data.code === 1000) {
            this.dataConfigRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
          } else {
            showMess(this, 'Error', data.message, 'danger', 'b-toaster-top-right', 3000)
          }
        } catch (error) {
          showMess(
            this,
            'Error',
            error.response?.data?.message || error.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            3000
          )
        }
      },
    },
  }
</script>
<style scoped>
  .action-h {
    height: 41px;
  }
</style>
